
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-report/[spotSlug]/[spotId]/spot-guide",
      function () {
        return require("private-next-pages/surf-report/[spotSlug]/[spotId]/spot-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-report/[spotSlug]/[spotId]/spot-guide"])
      });
    }
  